<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="provinceId">
            <el-select
              v-model="filterForm.provinceId"
              placeholder="请选择省"
              @change="
                handleChange(filterForm.provinceId, 'cityList', 'provinceName')
              "
              class="city-select"
            >
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item.n"
                :value="item.i"
              >
                {{ item.n }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="filterForm.provinceId" prop="cityId">
            <el-select
              v-model="filterForm.cityId"
              placeholder="请选择市"
              class="city-select"
              @change="handleChange(filterForm.cityId, 'areaList', 'cityName')"
            >
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.n"
                :value="item.i"
              >
                {{ item.n }}
              </el-option>
            </el-select></el-form-item
          >
          <el-form-item prop="areaId" v-if="filterForm.cityId"
            ><el-select
              v-model="filterForm.areaId"
              placeholder="请选择县"
              class="city-select"
              @change="
                handleChange(filterForm.areaId, 'countyList', 'areaName')
              "
            >
              <el-option
                v-for="(item, index) in areaList"
                :key="index"
                :label="item.n"
                :value="item.i"
              >
                {{ item.n }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="townId" v-if="filterForm.areaId"
            ><el-select
              v-model="filterForm.townId"
              placeholder="请选择乡镇"
              class="city-select"
              @change="
                handleChange(filterForm.townId, 'villageList', 'townName')
              "
            >
              <el-option
                v-for="(item, index) in countyList"
                :key="index"
                :label="item.n"
                :value="item.i"
              >
                {{ item.n }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="villageId" v-if="filterForm.townId">
            <el-select
              v-model="filterForm.villageId"
              placeholder="请选择村"
              class="city-select"
              @change="handleChange(filterForm.villageId, '', 'villageName')"
            >
              <el-option
                v-for="(item, index) in villageList"
                :key="index"
                :label="item.n"
                :value="item.i"
              >
                {{ item.n }}
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="fullName">
            <el-input
              v-model="filterForm.fullName"
              placeholder="村集体"
            ></el-input>
          </el-form-item>
          <el-form-item prop="personName">
            <el-input
              v-model="filterForm.personName"
              placeholder="联系人"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-cascader ref="regionCascader" :options="businessZoneList" :props="zoneProps" v-model="checkedZone" placeholder="业务区域">
            </el-cascader>
          </el-form-item>
          <el-form-item prop="businessPersonId">
            <el-select
              v-model="filterForm.businessPersonId"
              placeholder="业务负责人"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="(item, index) in dutyPersonList"
                :key="index"
                :label="item.personName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item>
            <el-button type="primary" @click="handleFilter()">查询</el-button>
            <el-button
              type="primary"
              plain
              icon="el-icon-refresh-right"
              @click="handleReset('filterForm')"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main">
      <el-table
        :data="tableData"
        style="width: 100%; margin-top: 10px"
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ (pagination.page - 1) * pagination.size + (scope.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="所在地"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="fullName"
          label="村集体"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="personName"
          label="联系人"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="businessPersonName"
          label="业务负责人"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="businessZoneName"
          label="业务区域"
          min-width="10%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="newBusiness"
          label="最新业务进展"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="newBusinessTime"
          label="时间"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" min-width="8%" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              plain
              round
              size="small"
              @click="lookDetail(row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-footer">
        <el-button
          type="primary"
          class="handle-btn"
          @click="changeAreaOrSalesman"
          >更换业务区域和业务员</el-button
        >
      </div>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.size"
        :total="pagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
      <ChangeDialog
        v-if="showDialog"
        @close="close"
        :showDialog="showDialog"
        :dataList="multipleSelection"
        type="village"
        @refreshList="getVillageList"
      ></ChangeDialog>
    </div>
  </el-main>
</template>

<script>
import ChangeDialog from "../../Cooperative/Management/ChangeDialog";
export default {
  name: "VillageManageList",
  data() {
    return {
      filterForm: {
        provinceId: "",
        cityId: "",
        areaId: "",
        townId: "",
        villageId: "",
        fullName: "",
        personName: "",
        businessZoneId: "", //业务区域id
        businessPersonId: "", //业务负责人id
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      tableData: [],
      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [], //业务负责人数据
      showDialog: false, // 弹窗
      multipleSelection: [], // 多选
      provinceList: [],
      cityList: [],
      areaList: [],
      countyList: [],
      villageList: [],
    };
  },
  components: { ChangeDialog },
  filters: {},
  watch: {
    checkedZone(newVal) {
      this.filterForm.businessPersonId = "";
      this.dutyPersonList = [];
      this.filterForm.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
  },
  created() {
    this.getVillageList();
    this.getBusinessZoneData();
    this.getSelectedCityOptions(1, "provinceList");
  },
  mounted() {},
  methods: {
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.filterForm.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 查询
    handleFilter() {
      this.pagination.page = 1;
      this.getVillageList();
    },
    //获取列表数据
    getVillageList() {
      let params = Object.assign({}, this.filterForm, {
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$http.village.villageListFilter(params).then((res) => {
        this.tableData = res.data.content;
        if (this.pagination.page == 1)
          this.pagination.total = res.data.recordTotal;
      });
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.checkedZone = [];
      setTimeout(() => {
        this.handleFilter();
      }, 500);
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getVillageList();
    },
    /**
     * @description: 更改区域或业务员
     * @Author: yangsibo
     * @Date: 2022-05-18 15:27:45
     * @param id
     * @return {*}
     */
    changeAreaOrSalesman() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请先勾选要操作的数据",
          duration: 2000,
        });
        return;
      }
      this.showDialog = true;
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-12 17:58:25
     */
    close() {
      this.showDialog = false;
    },
    /**
     * @description: 多选
     * @Author: yangsibo
     * @Date: 2022-05-18 14:56:05
     * @param val
     */
    selectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * @description: 查看村集体
     * @Author: quwandong
     * @Date: 2022-05-18 15:27:45
     * @param row
     */
    lookDetail(row) {
      const routeResolve = this.$router.resolve({
        path: "/village/trustee/contract",
        query: {
          $businessId: row.id,
          $businessName: row.fullName,
          $businessType: "_blank",
          $businessAccountId: row.accountId,
          $backPath: this.$route.path,
        },
      });

      window.open(routeResolve.href, "_blank");
    },
    /**
     * @description: 选中select后给name赋值同时获取子级数据
     * @Author: yangsibo
     * @Date: 2022-05-09 10:31:13
     * @param {*} pid
     * @param {*} type
     * @param {*} name
     * @return {*}
     */
    handleChange(pid, type, name) {
      let city = {};
      let list = "";
      switch (type) {
        case "cityList":
          this.filterForm.cityId = "";
          this.filterForm.areaId = "";
          this.filterForm.townId = "";
          this.filterForm.villageId = "";
          this.cityList = [];
          this.areaList = [];
          this.countyList = [];
          this.villageList = [];
          list = "provinceList";
          break;
        case "areaList":
          this.filterForm.areaId = "";
          this.filterForm.townId = "";
          this.filterForm.villageId = "";
          this.areaList = [];
          this.countyList = [];
          this.villageList = [];
          list = "cityList";
          break;
        case "countyList":
          this.filterForm.townId = "";
          this.filterForm.villageId = "";
          this.countyList = [];
          this.villageList = [];
          list = "areaList";
          break;
        case "villageList":
          this.filterForm.villageId = "";
          this.villageList = [];
          list = "countyList";
          break;
        case "":
          list = "villageList";
          break;
        default:
          break;
      }
      type && this.getSelectedCityOptions(pid, type);
    },
    /**
     * @description: 根据父id查询省市县乡村子地区
     * @Author: yangsibo
     * @Date: 2022-05-09 10:16:19
     * @param {string} pid 父级id
     * @param {string} type 赋值省市区数组
     * @param {*} name 省市区Name字段
     * @param {*} id 省市区对应数组
     */
    async getSelectedCityOptions(pid, type) {
      try {
        let { data } = await this.$http.common.getChildRegion({ pid });
        this[type] = data;
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.city-select {
  width: 160px;
}
.main {
  .list {
    .item {
      margin-bottom: 20px;
      .top-info {
        display: flex;
        align-items: center;
        color: #018388;
        .cell {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-right: 4%;
          &:first-child {
            flex-wrap: nowrap;
          }
          &:nth-child(4) {
            margin-right: 0;
          }
          &.number {
            font-weight: 900;
          }
        }
        .btn {
          height: 34px;
          line-height: 34px;
          padding: 0 15px;
          margin-left: auto;
        }
      }
      .el-table {
        margin-top: 10px;
      }
    }
  }
}
.btn-footer {
  width: 100%;
  display: flex;
  justify-content: right;
  margin: 15px 0;
}
</style>
